<form (ngSubmit)="submitForm(f)" #f="ngForm" [zeroLoadingIndicator]="ongoingRequest">
  @if (!ticketRef) {
    <div class="row">
      <div class="col-12 mb-2">
        <div class="input-group-material mt-4 mb-4">
          <input
            type="text"
            ngModel
            name="ticketSubject"
            id="ticketSubject"
            #ticketSubject
            [class.empty]="!ticketSubject.value"
            required
            maxlength="190"
          />
          <label for="ticketSubject" [innerHTML]="'tickets.create.subject' | transloco"> &nbsp; </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <div class="input-group-material select-dropdown">
          <select
            required
            ngModel
            name="ticketTopic"
            id="ticketTopic"
            #ticketTopic
            [class.empty]="!ticketTopic.value"
            (change)="handleTopicChange($event)"
          >
            <option value="" selected="true" disabled="disabled">
              {{ 'tickets.create.topic.hint' | transloco }}
            </option>
            @for (topic of topics$ | async; track topic.tag) {
              <option [value]="topic.tag">
                {{ topic.name }}
              </option>
            }
          </select>
          <label>{{ 'tickets.create.topic.label' | transloco }}</label>
        </div>
      </div>
    </div>
    @if (ticketTopic.value | hasTopicHint) {
      <div class="row">
        <div class="col-12 mb-3" [innerHTML]="'tickets.create.topic.defaults.' + ticketTopic.value | transloco"></div>
      </div>
    }
  }

  @if (ticketRef) {
    <h5>{{ 'tickets.create.answer.headline' | transloco }}</h5>
  }

  <div class="input-group-material pt-1">
    <textarea
      [value]="ticketText"
      (input)="ticketText = $any($event.target).value"
      [placeholder]="'tickets.create.answer.placeholder' | transloco"
      class="expanded"
      required
    ></textarea>
  </div>

  <div class="mt-2">
    <h5>{{ 'tickets.create.attachments.headline' | transloco }}</h5>
    @for (file of files; track file.fileName) {
      <div class="mb-0 mt-2 d-flex flex-wrap">
        <div>{{ file.fileName }}:&nbsp;</div>
        @if (!file.uploadError) {
          {{
            file.uploadInProgress
              ? ('tickets.create.attachments.progress.in-progress' | transloco)
              : ('tickets.create.attachments.progress.done' | transloco)
          }}
        }
        @if ((file.uploadProgress === 100 && file.uploadInProgress === false) || file.uploadError) {
          <a class="cursor-pointer" (click)="deleteUploadedFile(file)">
            <svg class="icon icon-24 icon-active mb-1 ml-2">
              <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
            </svg>
          </a>
        }
        @if (file.uploadError) {
          <div class="ml-2 text-color-error">
            {{ file.uploadError | transloco }}
          </div>
        }
      </div>
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          [class.bg-success]="file.uploadProgress === 100 && file.uploadInProgress === false && !file.uploadError"
          [class.bg-danger]="file.uploadError"
          [ngStyle]="{ width: file.uploadProgress + '%' }"
          [attr.aria-valuenow]="file.uploadError ? '0' : file.uploadProgress"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ file.uploadError ? '0' : file.uploadProgress }} %
        </div>
      </div>
    }

    @if (errors.length) {
      <div class="row mt-3">
        <div class="col-12 text-color-error">
          @for (err of errors; track $index) {
            <p>{{ err }}</p>
          }
        </div>
      </div>
    }

    <form #fileUpload="ngForm" (ngSubmit)="submitFileUpload(fileUpload, fileUploadElem)" class="mt-3">
      <input
        type="file"
        id="tempFiles"
        name="tempFiles"
        ngModel
        (change)="fileUpload.onSubmit($event)"
        multiple="multiple"
        #fileUploadElem
        accept="application/pdf, image/*"
        hidden
      />
      <label for="tempFiles" class="d-flex align-items-center">
        <web-design-system-button [isSubmit]="true" type="secondary" size="small" class="mr-3" (click)="fileUploadElem.click()">
          {{ 'tickets.create.attachments.files-upload.button' | transloco }}
        </web-design-system-button>
        <div class="font-size-smaller2 text-color-primary">{{ 'tickets.create.attachments.files-upload.hint' | transloco }}</div>
      </label>
    </form>
  </div>

  <div class="mt-4 d-flex align-items-center">
    <web-design-system-button class="mr-4" [disabled]="f.invalid || (files | uploadInProgress)" [isSubmit]="true">
      {{ 'tickets.create.submit' | transloco }}
    </web-design-system-button>
    <a class="link-secondary cursor-pointer" (click)="cancel()">{{ 'tickets.create.cancel' | transloco }}</a>
  </div>
</form>
